<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="编码">
              <j-input placeholder="请输入编码维护" v-model="queryParam.materialCode" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('膜皮手册维护表')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="copyUrl" slot-scope="text, record">
          <a @click="handleCopyUrl(record)">复制网址 </a>
        </span>
        <span class="not-wrap" slot="qrcode" slot-scope="text, record">
          <a @click="handleOpenQrCode(record)">查看二维码 </a>
        </span>
        <span class="not-wrap" slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <sample-block-modal ref="modalForm" @ok="modalFormOk"></sample-block-modal>
    <qr-code-modal fileType="sampleBlock" ref="qrCodeModal"></qr-code-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SampleBlockModal from './modules/SampleBlockModal.vue'
import QrCodeModal from './modules/QrCodeModal'
import JInput from '@/components/jeecg/JInput'

export default {
  name: 'MembraneList',
  mixins: [JeecgListMixin],
  components: {
    SampleBlockModal,
    QrCodeModal,
    JInput,
  },
  data() {
    return {
      description: '膜皮手册维护表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '编码',
          align: 'center',
          dataIndex: 'materialCode',
          width:"120px",
        },
        {
          title: '网址',
          align: 'center',
          dataIndex: 'picture',
        },
        {
          title: '二维码',
          align: 'center',
          scopedSlots: { customRender: 'qrcode' },
          width:"120px",
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width:"180px",
        },
      ],
      url: {
        list: '/sampleBlock/list',
        delete: '/sampleBlock/delete',
        deleteBatch: '/sampleBlock/deleteBatch',
        exportXlsUrl: '/sampleBlock/exportXls',
        importExcelUrl: 'sampleBlock/importExcel',
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    handleOpenQrCode(record) {
      this.$refs.qrCodeModal.open(record)
    },
    handleCopyUrl(record) {
      document.execCommand("copy",false,record.picture); // 执行浏览器复制命令
      alert("复制成功");
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.not-wrap{
  white-space: nowrap;
}
</style>